import { useTranslation } from 'react-i18next';
import { useEffect, useRef, useState } from 'react';
import { BaseButtonsForm } from '@app/components/common/forms/BaseButtonsForm/BaseButtonsForm';
import { BaseSelect, Option } from '@app/components/common/selects/BaseSelect/BaseSelect';
import { BaseButton } from '@app/components/common/BaseButton/BaseButton';
import { BaseSwitch } from '@app/components/common/BaseSwitch/BaseSwitch';
import { notificationController } from '@app/controllers/notificationController';
import { BaseRow } from '@app/components/common/BaseRow/BaseRow';
import { BaseCol } from '@app/components/common/BaseCol/BaseCol';
import { BaseInput } from '@app/components/common/inputs/BaseInput/BaseInput';
import { useAppDispatch } from '@app/hooks/reduxHooks';
import { updatePushNotificationAction, getPushNotificationByIdAction } from '@app/store/slices/userSlice';
import { useNavigate, useParams } from 'react-router-dom';
import { Form } from 'antd';

const formItemLayout = {
  labelCol: { span: 24 },
  wrapperCol: { span: 24 },
};

export const ValidationFormPushNotificationEdit: React.FC<any> = (props) => {
  const formRef = useRef<any>();
  const [isFieldsChanged, setFieldsChanged] = useState(false);
  const [isLoading, setLoading] = useState(true);
  const [formData, setFormData] = useState({});
  
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { id } = useParams();

  useEffect(() => {
    dispatch(getPushNotificationByIdAction(String(id))).unwrap().then((resp) => {
      if (resp && resp.data) {
        console.log('resp', resp);
        setFormData(resp.data);
        setLoading(false);
      }
    }).catch((err: any) => {
      setLoading(false);
      notificationController.error({ message: err.message });
    })
  }, []);

  const onFinish = async (values: any) => {
    setLoading(true);
    setFieldsChanged(false);
    
    values.id = id;
    console.log(values);
    
    // Set default values if not provided
    if (!values.isTemplate) values.isTemplate = false;
    
    dispatch(updatePushNotificationAction(values))
      .unwrap()
      .then((resp: any) => {
        setLoading(false);
        if (resp._id || resp.success) {
          notificationController.success({ message: t('common.success') });
          navigate('/admin/push-notifications/list');
        }
        else {
          notificationController.error({ message: 'Failed to update push notification' });
        }
      }).catch((err: any) => {
        setLoading(false);
        notificationController.error({ message: err.message });
      })
  };

  return (
    <>
      {!isLoading && <Form
        className='clinic-onboard-form'
        {...formItemLayout}
        ref={formRef}
        name="validateForm"
        initialValues={formData}
        onFinish={onFinish}
      >
        <BaseRow gutter={[10, 10]}>
          <BaseCol xs={24} sm={12}>
            <BaseButtonsForm.Item
              name="title"
              label={"Title"}
              rules={[{ required: true, message: "Title is required" }]}
            >
              <BaseInput />
            </BaseButtonsForm.Item>
          </BaseCol>

          <BaseCol xs={24} sm={12}>
            <BaseButtonsForm.Item
              name="description"
              label={"Description"}
              rules={[{ required: true, message: "Description is required" }]}
            >
              <BaseInput.TextArea rows={4} />
            </BaseButtonsForm.Item>
          </BaseCol>
        </BaseRow>

        <BaseRow gutter={[10, 10]}>
          <BaseCol xs={24} sm={12}>
            <BaseButtonsForm.Item
              name="templateType"
              label={"Template Type"}
            >
              <BaseSelect placeholder="Select template type">
                <Option value="general">General</Option>
                <Option value="promotional">Promotional</Option>
                <Option value="reminder">Reminder</Option>
                <Option value="alert">Alert</Option>
              </BaseSelect>
            </BaseButtonsForm.Item>
          </BaseCol>

          <BaseCol xs={24} sm={12}>
            <BaseButtonsForm.Item name="isTemplate" label="Is Template" valuePropName="checked">
              <BaseSwitch />
            </BaseButtonsForm.Item>
          </BaseCol>
        </BaseRow>

        <BaseRow gutter={[10, 10]}>
          <BaseCol xs={24} sm={12} md={12} xl={6}>
            <BaseButtonsForm.Item>
              <BaseButton type="primary" htmlType="submit" loading={isLoading}>
                {t('common.submit')}
              </BaseButton>
            </BaseButtonsForm.Item>
          </BaseCol>
        </BaseRow>
      </Form>
      }
    </>
  );
};
